import { useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const BG = "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export default function Login() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/sales" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="grid min-h-screen lg:grid-cols-[1.1fr_1fr]">
      <div className="relative hidden lg:block">
        <img src={BG} alt="Warehouse" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-[#01195D]/80" />
        <div className="relative flex h-full flex-col justify-between p-12 text-white">
          <div className="flex items-center gap-3">
            <div className="rounded-md bg-white px-4 py-2"><img src="/logo.png" alt="GS Pacific" className="h-9 w-auto" /></div>
          </div>
          <div>
            <h1 className="max-w-md text-4xl font-extrabold leading-tight tracking-tight">Quotes, customers and stock in one place.</h1>
            <p className="mt-4 max-w-sm text-sm text-slate-300">Build GST-ready quotes from live inventory and download a PDF for your customer in seconds.</p>
          </div>
          <div className="text-xs text-slate-400">sales.gspacific.com.au</div>
        </div>
      </div>
      <div className="flex items-center justify-center bg-white p-8">
        <form onSubmit={submit} className="w-full max-w-sm fade-up" data-testid="login-form">
          <img src="/logo.png" alt="GS Pacific" className="mb-8 h-10 w-auto lg:hidden" />
          <h2 className="text-2xl font-extrabold tracking-tight text-[#01195D]">Sign in</h2>
          <p className="mt-1 text-sm text-slate-500">Use your GS Pacific account.</p>
          <div className="mt-8 space-y-4">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5" data-testid="login-email-input" />
            </div>
            <div>
              <Label htmlFor="password">Password</Label>
              <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5" data-testid="login-password-input" />
            </div>
            {error && <p className="text-sm text-red-600" data-testid="login-error">{error}</p>}
            <Button type="submit" disabled={busy} className="w-full bg-[#01195D] hover:bg-[#0A2A7A]" data-testid="login-submit-btn">
              {busy ? "Signing in…" : "Sign in"}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
